// extracted by mini-css-extract-plugin
module.exports = {"embla-white-link":"WhiteEmblaLogo_embla-white-link__1xMLK"};